document.addEventListener('DOMContentLoaded', function () {
  var burger = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('.site-nav');

  if (burger && nav) {
    burger.addEventListener('click', function () {
      var isOpen = nav.style.display === 'flex';
      nav.style.display = isOpen ? 'none' : 'flex';
      nav.style.flexDirection = 'column';
      nav.style.position = 'absolute';
      nav.style.top = '64px';
      nav.style.left = '0';
      nav.style.right = '0';
      nav.style.background = 'rgba(255,255,255,0.98)';
      nav.style.padding = '20px 24px';
      nav.style.gap = '16px';
    });
  }
});
